import { Link, Outlet } from "react-router-dom";

export default function NavBarFooter({ onScrollToAbout, onScrollToMission,onScrollToJoin }) {
    return (<>
        <div className="px-4 mx-auto max-w-7xl sm:px-6 ">
            <div className="relative pt-6 pb-16 sm:pb-24 ">
                <nav
                    className="relative flex items-center justify-between sm:h-10 md:justify-center rounded-lg bg-jfePurple"
                    aria-label="Global">
                    <div className="flex items-center flex-1 md:absolute md:inset-y-0 md:left-0">
                        <div className="flex items-center justify-between w-full md:w-auto">
                            <Link to="/">
                                <img alt="" className="w-auto h-8 sm:h-10" src="favicon.ico" loading="lazy"
                                    width="202" height="40" />
                            </Link>
                            <div className="flex items-center -mr-2 md:hidden">
                                <button

                                    className="inline-flex items-center justify-center p-2 text-white bg-gray-50 rounded-md hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-gray-50"
                                    type="button" aria-expanded="false">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                        strokeWidth="2" stroke="currentColor" aria-hidden="true"
                                        className="w-6 h-6">
                                        <path strokeLinecap="round" strokeLinejoin="round"
                                            d="M4 6h16M4 12h16M4 18h16"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="hidden md:flex md:space-x-10 list-none">
                        <li>
                            <button
                                onClick={onScrollToAbout}
                                className="text-base font-normal font-serif text-white list-none hover:text-gray-900">
                                About us
                            </button>
                        </li>
                        <li>
                            <button
                                onClick={onScrollToMission}
                                className="text-base font-normal font-serif text-white list-none hover:text-gray-900">
                                Mission
                            </button>
                        </li>
                        <li>
                            <Link to="/gallery" className="text-base font-normal font-serif text-white list-none hover:text-gray-900" target="_blank">Gallery</Link>
                        </li>
                    </div>
                    <div
                        className="hidden md:absolute md:flex md:items-center md:justify-end md:inset-y-0 md:right-0">
                        <div className="inline-flex rounded-lg shadow">
                            <div onClick={onScrollToJoin}
                                className="inline-flex items-center px-4 py-2 text-base text-gray-900 bg-white border-1 border-l-0 border-jfePurple rounded-lg rounded-l-none  cursor-pointer font-base hover:bg-gray-50">                                 Join
                            </div>
                        </div>
                    </div>
                </nav>

            </div>
        </div>
        <Outlet />
        <div className="px-4 pt-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8">
            <div className="grid gap-10 row-gap-6 mb-8 sm:grid-cols-2 lg:grid-cols-4">
                <div className="sm:col-span-2">
                    <a href="/" aria-label="Go home" title="Company" className="inline-flex items-center">
                        <svg className="w-8 text-deep-purple-accent-400" viewBox="0 0 24 24" stroke-linejoin="round"
                            stroke-width="2" stroke-linecap="round" stroke-miterlimit="10" stroke="currentColor"
                            fill="none">
                            <rect x="3" y="1" width="7" height="12"></rect>
                            <rect x="3" y="17" width="7" height="6"></rect>
                            <rect x="14" y="1" width="7" height="6"></rect>
                            <rect x="14" y="11" width="7" height="12"></rect>
                        </svg>
                        <span className="ml-2 text-xl font-bold font-serifs tracking-wide text-gray-800 uppercase">Joy for Everyone</span>
                    </a>

                </div>
                <div className="space-y-2 text-sm">
                    <p className="text-base font-bold font-serifs tracking-wide text-gray-900">Contacts</p>
                    <div className="flex">
                        <p className="mr-1 text-gray-800">Phone:</p>
                        <a href="tel:0770 511 838" aria-label="Our phone" title="Our phone"
                            className="transition-colors duration-300 text-deep-purple-accent-400 hover:text-deep-purple-800">0746
                            811 472<br />0770 511 838<br />0764 860 679</a>
                    </div>
                    <div className="flex">
                        <p className="mr-1 text-gray-800">Email:</p>
                        <a href="mailto:jfetimisoara@gmail.com" aria-label="Our email" title="Our email"
                            className="transition-colors duration-300 text-deep-purple-accent-400 hover:text-deep-purple-800">jfetimisoara@gmail.com</a>
                    </div>
                </div>
                <div>
                    <span className="text-base font-bold font-serifs tracking-wide text-gray-900">Social</span>
                    <div className="flex items-center mt-1 space-x-3">
                        <a href="https://www.instagram.com/joy.for.everyone/"
                            className="text-gray-500 transition-colors duration-300 hover:text-deep-purple-accent-400">
                            <svg viewBox="0 0 30 30" fill="currentColor" className="h-6">
                                <circle cx="15" cy="15" r="4"></circle>
                                <path
                                    d="M19.999,3h-10C6.14,3,3,6.141,3,10.001v10C3,23.86,6.141,27,10.001,27h10C23.86,27,27,23.859,27,19.999v-10   C27,6.14,23.859,3,19.999,3z M15,21c-3.309,0-6-2.691-6-6s2.691-6,6-6s6,2.691,6,6S18.309,21,15,21z M22,9c-0.552,0-1-0.448-1-1   c0-0.552,0.448-1,1-1s1,0.448,1,1C23,8.552,22.552,9,22,9z"
                                ></path>
                            </svg>
                        </a>
                        <a href="https://www.facebook.com/people/Joy-for-Everyone/100091677965054/"
                            className="text-gray-500 transition-colors duration-300 hover:text-deep-purple-accent-400">
                            <svg viewBox="0 0 24 24" fill="currentColor" className="h-5">
                                <path
                                    d="M22,0H2C0.895,0,0,0.895,0,2v20c0,1.105,0.895,2,2,2h11v-9h-3v-4h3V8.413c0-3.1,1.893-4.788,4.659-4.788 c1.325,0,2.463,0.099,2.795,0.143v3.24l-1.918,0.001c-1.504,0-1.795,0.715-1.795,1.763V11h4.44l-1,4h-3.44v9H22c1.105,0,2-0.895,2-2 V2C24,0.895,23.105,0,22,0z"
                                ></path>
                            </svg>
                        </a>
                    </div>

                </div>
            </div>

        </div>
    </>
    )
}